import React from "react"

export default function Dropdown() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_3_6293)">
            <path d="M8.15661 10.1621H16.5238C17.2761 10.1621 17.6523 11.0727 17.1214 11.6035L12.9379 15.7871C12.6074 16.1176 12.073 16.1176 11.7461 15.7871L7.55895 11.6035C7.02809 11.0727 7.40426 10.1621 8.15661 10.1621Z" fill="#5B5E71" />
         </g>
         <defs>
            <clipPath id="clip0_3_6293">
               <rect width="11.25" height="18" fill="white" transform="translate(6.71582 3.16211)" />
            </clipPath>
         </defs>
      </svg>
   )
}
